module.exports = __webpack_public_path__ + "img/faq-account.de32cb7b.svg";